import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';
import PropTypes from 'prop-types';
import React from 'react';
import TopNavBar from '../../../TopNavBar';
import BreadCrumb from '../../../common/components/with_page/components/bread_crumb/BreadCrumb';
import './OrbitPageLayout.css';

const OrbitPageLayout = ({ children, breadCrumbItems, fullBleedContent }) => {
  return (
    <div className="orbit-page">
      <TopNavBar />
      {fullBleedContent ? (
        children
      ) : (
        <AppLayout
          breadcrumbs={<BreadCrumb items={breadCrumbItems} />}
          content={<div className="awsui-grid awsui-util-p-s app-content-div">{children}</div>}
          navigationHide
          toolsHide
        />
      )}
    </div>
  );
};

OrbitPageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  breadCrumbItems: PropTypes.array,
  fullBleedContent: PropTypes.bool,
};

OrbitPageLayout.defaultProps = {
  breadCrumbItems: [],
  fullBleedContent: false,
};

export default OrbitPageLayout;
